<template>
  <div>
    <div class="newsdetails">
      <div class="module">
        <div class="top">
          <span v-jump="'/news'">新闻动态</span>
          <div></div>
          <span>{{data.title}}</span>
        </div>
        <div class="middle">
          <div class="title">{{data.title}}</div>
          <div class="time">{{data.time}}</div>
          <div class="p" v-for="(item,index) in data.p" :key="index">{{item}}</div>
        </div>
        <div class="bottom">
          <div class="list">
            <div>
              上一篇：
              <span class="none" v-if="!isF">您正在阅读的是第一篇文章</span>
              <span
                class="y"
                v-if="isF"
                v-jump="'/news/newsdetails'+( Number(id) - 1)"
              >{{list[list.length - (Number(id) - 1)].title}}</span>
            </div>
            <div>
              下一篇：
              <span class="none" v-if="!isE">您正在阅读的是最后一篇文章</span>
              <span
                class="y"
                v-if="isE"
                v-jump="'/news/newsdetails'+( Number(id) + 1)"
              >{{list[list.length - (Number(id) + 1)].title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-newsDetail">
      <div class="mobile-bannerTemp">
      </div>
      <div class="news-content">
        <div class="title">{{data.title}}</div>
        <div class="time">{{data.time}}</div>
        <div class="line"></div>
        <div class="content">
          <p v-for="(item,index) in data.p" :key="index">{{item}}</p>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Newsdetails",

  metaInfo() {
    return {
      title:
        this.data.title + "_三维可视化行业新闻动态-上海臻图信息技术有限公司",
      meta: [
        {
          name: "description",
          content: this.data.p[0].slice(0, 40) + "..."
        }
      ]
    };
  },
  data() {
    return {
      list: [
        {
          time: "2018-03-30",
          title: "祝贺臻图科技GIS空间引擎软件V1.0成功通过科委科技成果验收",
          p: [
            "由我司研发的自主知识产权的GIS空间引擎软件，参加上海市科技企业创新项目评审，经过专家的层层评审，凭借独特的技术和应用创新优势，以及全面超预期完成的指标数据，获得专家委员会的一致认可，成功验收。这标志着臻图科技在GIS大数据服务方面已建立了一套科学有效的管理体系，同时也意味着臻图科技在空间信息服务能力和水平上达到了一定的国内领先和国际先进水准。"
          ]
        },
        {
          time: "2017-11-05",
          title: "臻图科技亮相第十一届中国智慧城市技术建设技术研讨会",
          p: [
            "11月3日上午9点，第十一届中国智慧城市技术建设技术研讨会暨设备博览会在北京国际会议中心隆重开幕。上海臻图信息技术有限公司作为参展商受邀出席研讨会暨博览会。",
            "展会上众多智慧城市建设领域的科研机构，行业联盟，通讯运营商等，对臻图科技的智慧城市GIS平台很感兴趣，其中多家测绘地理信息单位、物联网企业分别看重臻图科技的智慧社区平台、智能商业平台等，现场工作人员分别为他们做了相关平台的演示操作，并进行了深入地沟通，他们对臻图科技的平台运作模式、系统功能等给予了高度肯定。",
            "本次邀请智慧城市（含智慧园区、智慧社区等）建设管理部门，智慧城市建设领域的科研机构，行业联盟，通讯运营商，跨国公司及国内外知名软、硬件企业参加智慧城市大会展览，展示国内外最新技术、产品与应用成果。作为国内卓越的GIS行业信息化领军企业，臻图科技专业的科技化企业形象、丰富多样的产品服务备受瞩目。",
            "前来参观交流的企业和领导给了公司及团队很大的肯定和鼓舞，臻图科技会以更专业、高效、创新的产品及解决方案积极参与到智慧城市的建设中来。"
          ]
        },
        {
          time: "2016-08-02",
          title: "臻图科技成功中标海信集团海上云GIS共享平台项目",
          p: [
            " 2016年8月1日，凭借我司对GIS行业的了解以及专业技术优势，通过对青岛海信集团海上云GIS项目的分析和理解，我司成功中标海信集团海上云GIS共享平台项目。"
          ]
        },
        {
          time: "2016-06-12",
          title: "成功中标中科院土地空间数据GIS共享平台项目",
          p: [
            "经过对项目需求的分析和调研，凭借对行业的了解以及专业技术实力优势，我司成功中标中科院土地空间数据GIS共享平台项目。"
          ]
        },
        {
          time: "2016-05-16",
          title: "我司获得上海市科技创业基金会的立项支持",
          p: [
            " 在经历了基金会的摸底调研和数轮答辩后，我司凭借“高性价比自主知识产权的ZTMapGIS平台”项目，获得各专业和投资专家的一致认可，正式决定对我们公司进行立项支持，我司将作为上海市科技创业基金会的重点支持和孵化企业，基金会将在资金和指导服务方面为我司注入强大的动力。",
            "这是公司持续创新、永续经验道路上的一个重要推动力，扩宽了公司的不断发展壮大之路！",
            "（上海市科技创业基金会是政府组织成立的，由各级政府科委、财政部门牵头，各大VC投资公司、银行等参与的机构，致力于为上海市科技型创新企业提供政策和资金扶持）"
          ]
        },
        {
          time: "2016-04-23",
          title: "ZTMap智慧旅游产品正式上线！",
          p: [
            "ZTMap智慧旅游产品是基于自主知识产权的GIS平台ZTMap开发的，适用于旅游景区应用的可视化产品，实现了基于微信、APP的手机景区地图浏览查询和智能游览功能，用户可以基于微信公众号或APP实现景区地图的随时查看，实现二三维地图、三维全景、自动路线游览等丰富的功能。"
          ]
        },
        {
          time: "2016-04-23",
          title: "ZTMap GIS V1.1 正式发布！",
          p: [
            "ZTMap GIS V1.1版本正式发布，ZTMap平台产品在经历了V1.0版本两年多的成功应用后，经过深度优化和最新技术的应用，成功研发成功V1.1版本，该版本在地图前端渲染的效率和效果方面得到了大幅提升，同时在跨平台兼容性方面进行了更为深入的开发，该产品将会为用户带来业界领先的地图用户体验。"
          ]
        },
        {
          time: "2016-03-21",
          title: "我司成为上海移动合格供应商",
          p: [
            "依靠强劲的技术实力和优质的技术服务，我司正式成为上海移动的合格供应商，并成功为其实施基于GIS的内网可视化资产管理系统的合作开发。 这标志着我们的产品和服务获得了顶级服务商的认可。"
          ]
        },
        {
          time: "2016-01-13",
          title:
            "祝贺公司“ZTMap高性价比GIS平台产品V1.0”获得闵行区科技创新项目立项",
          p: [
            "我司研发的自主知识产权的GIS产品“ZTMap高性价比GIS平台产品V1.0” ，参加上海市闵行区科技企业创新项目评审，经过专家的层层评审，凭借独特的技术和应用创新优势，获得专家委员会的一致认可，获得科委的立项支持。这标志着我们立足技术创新战略获得认可，是对我们公司团队的极大激励和支持。我们定会坚持以市场为导向，以创新为根本，继续努力！"
          ]
        },
        {
          time: "2015-05-04",
          title: "公司成功参与智慧城市项目建设",
          p: [
            "经过数月的前期技术交流和DEMO演示，公司成功参与到河南某市的智慧城市建设，参与承担智慧城管平台的建设，ZTMap产品将在该平台的建设中充分发挥地图服务技术的优势特点，使其成为该平台的一大亮点。"
          ]
        }
      ],
      data: {},
      id: null
    };
  },
  watch: {
    $route: "fetchData"
  },
  computed: {
    isF: function() {
      let id = this.$route.params.id.split("newsdetails")[1];
      return id != 1 ? true : false;
    },
    isE: function() {
      let id = this.$route.params.id.split("newsdetails")[1];
      let length = this.list.length;
      return id != length ? true : false;
    }
  },
  methods: {
    fetchData: function() {
      this.id = this.$route.params.id.split("newsdetails")[1];
      this.data = this.list[this.list.length - this.id];
    }
  },
  created: function() {
    this.id = this.$route.params.id.split("newsdetails")[1];
    this.data = this.list[this.list.length - this.id];
  }
};
</script>

<style lang="less" scoped>
//scoped

.newsdetails {
  padding-top: 70px;
  .top {
    margin-top: 70px;
    line-height: 14px;
    display: flex;
    align-items: center;
    span {
      font-size: 14px;
      margin-left:5px;
      &:first-child {
        color: #cccccc;
        cursor: pointer;
      }
      &:last-child {
        color: #7c7c7c;
      }
    }
    div {
      width: 7px;
      height: 12px;
      display: inline-block;
      background: url("../../assets/images/newsdetails/arrow_right.png")
        no-repeat center center/100% 100%;
      vertical-align: middle;
      margin-left:5px;
    }
  }
  .middle {
    margin-top: 100px;
    .title {
      font-size: 40px;
      color: rgba(58, 58, 58, 1);
      text-align: center;
    }
    .time {
      font-size: 18px;
      color: rgba(153, 153, 153, 1);
      text-align: center;
      margin: 30px 0 80px 0;
    }
    .p {
      font-size: 16px;
      color: rgba(124, 124, 124, 1);
      line-height: 32px;
      text-indent: 32px;
    }
  }
  .bottom {
    margin: 80px 0 170px 0;
    font-size: 16px;
    text-align: right;
    color: #4b4b4b;
    .list {
      display: inline-block;
      > div {
        text-align: left;
        &:first-child {
          margin-bottom: 10px;
        }
        span.none {
          color: #7c7c7c;
        }
        span.y:hover {
          color: #0276f7;
          cursor: pointer;
        }
      }
    }
  }
}
.mobile-newsDetail {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .news-content {
    width: 100%;
    box-sizing: border-box;
    padding: 2rem 1.5rem;
    margin-top: 5rem;
    color: #333;
    .title {
      font-size: 2rem;
      font-weight: bold;
      line-height: 3rem;
    }
    .time {
      color: #7c7c7c;
      margin-top: 2rem;
      font-size: 1rem;
    }
    .line {
      background: #7c7c7c ;
      width: 100%;
      height: 1px;
      margin-top: 1rem;
    }
    .content {
      width: 100%;
      margin-top: 2rem;
      p {
        text-indent: 2em;
        color: #7c7c7c;
        font-size: 1rem;
        margin: 0;
        line-height: 1.5rem;

      }
    }
  }
}
@media (max-width: 1024px) {
  .newsdetails {
    display: none !important;
  }
  .mobile-newsDetail { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news/newsdetails.vue